import { object, ObjectSchema, string, boolean } from 'yup';
import { IAuthFormData } from '../model/types/AuthFormData';

export const authDataSchema: ObjectSchema<IAuthFormData> = object({
  email: string().required('Enter login').email('Invalid email'),
  password: string().required('Enter password'),
  remember: boolean().default(false),
});
